export default __webpack_public_path__ + "locales/uk-UA/DeleteDialog.json?hash=f3643a663dab2e124a16e78e92c0939c";